function updateTimer() {
  const hoursElement = document.getElementById("hours");
  const minutesElement = document.getElementById("minutes");
  const secondsElement = document.getElementById("seconds");
  if (!hoursElement || !minutesElement || !secondsElement) return;

  const now = new Date();
  const nextResetTime = new Date();
  nextResetTime.setHours(24, 0, 0, 0);
  const timeRemaining = nextResetTime - now;

  const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeRemaining / (1000 * 60)) % 60);
  const seconds = Math.floor((timeRemaining / 1000) % 60);

  hoursElement.textContent = hours.toString().padStart(2, '0') + "h ";
  minutesElement.textContent = minutes + "m ";
  secondsElement.textContent = seconds + "s ";
}

setInterval(updateTimer, 1000);
updateTimer();

document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const sizeGuideOverlay = document.querySelector(".size-guide__overlay");
  const sizeGuide = document.querySelector(".size-guide");

  body.addEventListener("click", (event) => {
    if (
      sizeGuideOverlay &&
      sizeGuide &&
      (event.target.classList.contains("desktop-size") ||
        event.target.closest(".desktop-size"))
    ) {
      sizeGuideOverlay.classList.add("active");
      sizeGuide.classList.add("active");
      body.classList.add("size-guide-open");
    }
  });

  body.addEventListener("click", (event) => {
    if (
      sizeGuideOverlay &&
      sizeGuide &&
      (event.target.classList.contains("mobile-size") ||
        event.target.closest(".mobile-size"))
    ) {
      sizeGuideOverlay.classList.add("active");
      sizeGuide.classList.add("active");
      body.classList.add("size-guide-open");
    }
  });
  body.addEventListener("click", (event) => {

    if (
      event.target.classList.contains("size-guide__close") ||
      event.target.classList.contains("size-guide__overlay") ||
      event.target.closest(".size-guide__cross")
    ) {
      sizeGuideOverlay.classList.remove("active");
      sizeGuide.classList.remove("active");
      body.classList.remove("size-guide-open");
    }
  });

  initializeProductSpollers();
});

const unitRadioButtons = document.querySelectorAll('input[name="unit"]');

function updateSizeVisibility() {
  const selectedUnitInput = document.querySelector('input[name="unit"]:checked');
  if (!selectedUnitInput) return;
  const selectedUnit = selectedUnitInput.value;
  const inSizeElements = document.querySelectorAll(".in-size");
  const cmSizeElements = document.querySelectorAll(".cm-size");

  inSizeElements.forEach((el) => {
    const tagName = el.tagName.toLowerCase();
    if (tagName === "span") {
      el.style.display = selectedUnit === "inches" ? "inline" : "none";
    } else if (tagName === "table") {
      el.style.display = selectedUnit === "inches" ? "table" : "none";
    } else {
      el.style.display = selectedUnit === "inches" ? "table-cell" : "none";
    }
  });

  cmSizeElements.forEach((el) => {
    const tagName = el.tagName.toLowerCase();
    if (tagName === "span") {
      el.style.display = selectedUnit === "inches" ? "none" : "inline";
    } else if (tagName === "table") {
      el.style.display = selectedUnit === "inches" ? "none" : "table";
    } else {
      el.style.display = selectedUnit === "inches" ? "none" : "table-cell";
    }
  });
}

function updateSizeVisibilityLeg() {
  const selectedUnitInput = document.querySelector('input[name="unit"]:checked');
  if (!selectedUnitInput) return;
  const selectedUnit = selectedUnitInput.value;
  const inSizeElements = document.querySelectorAll(".in-size-leg");
  const cmSizeElements = document.querySelectorAll(".cm-size-leg");

  inSizeElements.forEach((el) => {
    if (el.tagName.toLowerCase() === "span") {
      el.style.display = selectedUnit === "inches" ? "inline" : "none";
    } else {
      el.style.display = selectedUnit === "inches" ? "table-cell" : "none";
    }
  });

  cmSizeElements.forEach((el) => {
    if (el.tagName.toLowerCase() === "span") {
      el.style.display = selectedUnit === "inches" ? "none" : "inline";
    } else {
      el.style.display = selectedUnit === "inches" ? "none" : "table-cell";
    }
  });
}

unitRadioButtons.forEach((rb) => {
  rb.addEventListener("change", updateSizeVisibility);
});

updateSizeVisibility();
updateSizeVisibilityLeg();

function initializeProductSpollers() {
  const spollerBlocks = document.querySelectorAll(".spollers-block._spollers");

  spollerBlocks.forEach((block) => {
    const isSingleOpen = block.classList.contains("_one");
    const items = [...block.children].filter((child) =>
      child.classList.contains("spollers-block__item")
    );

    items.forEach((item) => {
      const title = item.querySelector(".spollers-block__title");
      const body = item.querySelector(".spollers-block__body");
      if (!title || !body) return;

      const isActive = title.classList.contains("_active");
      title.setAttribute("aria-expanded", isActive ? "true" : "false");
      body.style.display = "block";
      body.style.overflow = "hidden";
      body.style.transition = "height 0.32s ease, opacity 0.24s ease";
      body.style.height = isActive ? "auto" : "0px";
      body.style.opacity = isActive ? "1" : "0";
      body.hidden = !isActive;

      if (title.dataset.spollerBound === "true") return;
      title.dataset.spollerBound = "true";

      title.addEventListener("click", () => {
        const currentlyActive = title.classList.contains("_active");

        if (isSingleOpen) {
          items.forEach((otherItem) => {
            const otherTitle = otherItem.querySelector(".spollers-block__title");
            const otherBody = otherItem.querySelector(".spollers-block__body");
            if (!otherTitle || !otherBody) return;
            if (otherTitle !== title) {
              closeSpoller(otherTitle, otherBody);
            }
          });
        }

        if (!currentlyActive) {
          openSpoller(title, body);
        } else {
          closeSpoller(title, body);
        }
      });
    });
  });
}

function openSpoller(title, body) {
  title.classList.add("_active");
  title.setAttribute("aria-expanded", "true");
  body.hidden = false;
  body.style.display = "block";
  body.style.overflow = "hidden";
  body.style.height = "0px";
  body.style.opacity = "0";

  requestAnimationFrame(() => {
    body.style.height = `${body.scrollHeight}px`;
    body.style.opacity = "1";
  });

  const handleOpenEnd = (event) => {
    if (event.propertyName !== "height") return;
    body.style.height = "auto";
    body.removeEventListener("transitionend", handleOpenEnd);
  };

  body.addEventListener("transitionend", handleOpenEnd);
}

function closeSpoller(title, body) {
  if (!title.classList.contains("_active") && body.hidden) return;

  title.classList.remove("_active");
  title.setAttribute("aria-expanded", "false");
  body.style.overflow = "hidden";
  body.style.height = `${body.scrollHeight}px`;
  body.style.opacity = "1";

  requestAnimationFrame(() => {
    body.style.height = "0px";
    body.style.opacity = "0";
  });

  const handleCloseEnd = (event) => {
    if (event.propertyName !== "height") return;
    body.hidden = true;
    body.removeEventListener("transitionend", handleCloseEnd);
  };

  body.addEventListener("transitionend", handleCloseEnd);
}

function initializeHoverEffect() {
  const elements = document.querySelectorAll(".product-media__right");

  elements.forEach((element) => {
    element.addEventListener("mouseenter", () => {
      element.classList.add("has-hovered");
    });
  });
}

document.addEventListener("DOMContentLoaded", initializeHoverEffect);
document.addEventListener("updateGallery", initializeHoverEffect);
document.addEventListener("product-info:loaded", initializeProductSpollers);
